import api from "../Api.js";

export default () => {
  async function saveConfigCss(cssConfig) {
    return await api().post("/config/css/salvar", cssConfig);
  }

  async function saveNewConfigCss(cssConfig) {
    return await api().post("/config/css/new/salvar", cssConfig);
  }

  async function getConfigCss(cliente) {
    return await api().get(`/config/css/${cliente}`);
  }

  async function getNewConfigCss(cliente) {
    return await api().get(`/config/css/new/${cliente}`);
  }

  async function getNewConfigCssCompleto() {
    return await api().get("/config/css/new/completo");
  }

  async function getConfigCssCompleto() {
    return await api().get("/config/css/completo");
  }

  async function getStatesCss() {
    return await api().get("/config/css/estado");
  }

  async function getStatesAtencaoCss() {
    return await api().get("/config/css/estado-atencao");
  }

  return {
    saveConfigCss,
    getConfigCss,
    getStatesCss,
    getStatesAtencaoCss,
    getConfigCssCompleto,
    getNewConfigCss,
    getNewConfigCssCompleto,
    saveNewConfigCss
  };
};
